import { MUTATION_KEY, QUERY_KEY } from "constants/globalConstants";
import ApiService from "apiService";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useEditScheduleDowntime = (handleModalClose) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.EDIT_SCHEDULE_DOWNTIME],
    (data) => ApiService.editScheduleDowntime(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_SCHEDULE_DOWNTIME_LIST);
        handleModalClose()
        toast.success("Down time edited successfully");
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );
};

export default useEditScheduleDowntime;